import {defaultEnv} from './environment.default';
import {Environment} from './environment.interface';

export const devEnv: Environment = {
  env: 'dev',
  language: defaultEnv.language,
  serviceWorker: 'service.worker.dev.js'
};
